import React from 'react';
import { useSelector} from 'react-redux';
import NuInsStepper from '../elements/NuInsStepper';
import {steppLabels} from './common/types';
import {BackIcon} from '../svg/iconsSvg';
import { Divider } from 'rsuite';
import OwnerDetailsPerson from './OwnerDetailsPerson';
import OwnerDetailsCompany from './OwnerDetailsCompany';

const OwnerDetailsContainer = ({onBack, onForward, style}) => {

    const {ownerType}  = useSelector(state => state.questionsPolicy);

    const goBack = () => {
        onBack(7)
    }

    const goForward = () => {
        onForward(9);
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head" style={{paddingTop: '0', marginBottom: '-18px'}}>
                <div className="head-icon" style={{margin: '0 -8px 0 4px'}} onClick={goBack}><BackIcon size={32}/></div>
                <NuInsStepper activeStep={3} steps={4} labels={steppLabels}/>
            </div>
            <Divider />
            {ownerType === '0' && <OwnerDetailsPerson onSubmit={goForward}/> }
            {ownerType === '1' && <OwnerDetailsCompany onSubmit={goForward}/> }
        </div>
    )
}

export default OwnerDetailsContainer;